const restoreStandPosition = ({
    history,
    pathname,
    state,
    rafIdRef,
    maxAttempts = 90
}) => {
    if (!state?.returnStandId) {
        return () => {};
    }

    let attempts = 0;

    const tryRestoreByStandId = () => {
        attempts += 1;
        const standNode = document.querySelector(`[data-stand-id="${ state.returnStandId }"]`);

        if (standNode) {
            const rect = standNode.getBoundingClientRect();
            const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
            const isVisible = rect.top >= 0 && rect.bottom <= viewportHeight;

            if (!isVisible) {
                standNode.scrollIntoView({
                    block: "center",
                    behavior: "auto"
                });
            }

            if (!state.standPositionChanged) {
                history.replace({
                    pathname
                }, {
                    ...state,
                    standPositionChanged: true
                });
            }

            rafIdRef.current = null;
            return;
        }

        if (attempts < maxAttempts) {
            rafIdRef.current = window.requestAnimationFrame(tryRestoreByStandId);
        } else {
            rafIdRef.current = null;
        }
    };

    rafIdRef.current = window.requestAnimationFrame(tryRestoreByStandId);

    return () => {
        if (rafIdRef.current) {
            window.cancelAnimationFrame(rafIdRef.current);
            rafIdRef.current = null;
        }
    };
};

export default restoreStandPosition;
